<!-- <template>
	<h3 style="color:#fff">HTTP Error 401: Unauthorized Access
		- You have attempted to access a page for which you are not authorized.
	</h3>
</template> -->
<template>
	<div>
	   <img class="img-fluid col-md-10"  src="/static/img/blueprintlogologin.png" alt="..."/>
	   <br/><br/>
	   <div class="text-title"><b>HRIS</b> - Human Resource Information System</div>
	   <br/>
	   <!-- <card> -->
		  <template slot="header">
			 Login
		  </template>
		  <div class="row">
			 <div class="col-md-12">
				<form @submit.prevent="login">
				   <input type="text" class="form-control form-field"  v-on:click="hide_message" v-model="uname" v-bind:class="{ 'is-invalid': error_handler}" placeholder="Username" autocomplete="off" required>
				   <br/>
				   <br/>
				   <input type="password" class="form-control form-field" v-on:click="hide_message" v-model="upass" v-bind:class="{ 'is-invalid': error_handler}" placeholder="Password" autocomplete="off" required>
				   <br/>
				   <div v-if="error_handler" class="alert alert-danger">
					  <strong><i class="fa fa-warning"></i>&nbsp;Warning </strong> <b>error:</b> {{ error_handler }}
				   </div>
				   <br/>
				   <button class="btn btn-info ">
				   <i class="fa fa-user"></i>&nbsp; Login Account
				   <span v-if="seen">
				   <img  src="static/img/loading.gif" alt="" width="25" height="25">
				   </span>
				   </button>
				   &nbsp;
					 <router-link to="/reset/password"><u>Forgot Password ?</u></router-link>
				   <br/>
				</form>
				<br/>	
			 </div>
		  </div>
	   <!-- </card> -->
	   <div class="text-style">Copyright &copy; 2019 Blueprint Business Solution Corp<br/> version 7.2.0 LTS</div>
	</div>
 </template>

<script>
/* eslint-disable */
import axios from 'axios'
import store from '../../../store'
import Card from 'src/components/UIComponents/Cards/Card.vue'

export default {
 components: {
	 Card
 },
 
 data () {
	return {
		uname:'',
		upass:'',
		output:'',
		items:[],
		error_handler:'',
		seen:false,
		access_address:''
	}
},
mounted:function(){
	fetch('https://api.ipify.org?format=json')
      .then(x => x.json())
      .then(({ ip }) => {
       console.log(this.term = ip)
    });
},
 methods:{	

	hide_message(){
	   this.error_handler = false
	},
	login(){

		var auth = { name : this.uname, password : this.upass }	
		axios.post('api/login',auth)
		.then(resp => {
			this.seen = true
				if(resp.data.user_type == 5){
					setTimeout(() => { 
						this.seen = false;
						this.$router.push({ name: 'Dashboard' })
					}, 2000);	
					/**	
					* STORE TOKEN ON LOCAL STORAGE 
					*/
					store.commit('loginUser')
					localStorage.setItem('token', resp.data.access_token)
					localStorage.setItem('expiration',resp.data.expires_at + Date.now()) 
				
				}else{
					this.uname = ''
					this.upass = ''
					this.seen = false;
					this.error_handler = 'Access Denied !'
					this.$router.push({ name: 'Login-Layout' })
				}
				
		  })
		 .catch(error => {
			this.error_handler = error.response.data.error
			console.log(error.response.data.error)
			this.uname = ''
			this.upass = ''
		})		
	}
 },

 watch:{
	 error_handler(){
		 console.log('response =>',JSON.stringify(this.error_handler));
	 }
 }

}
</script>
<style>
 .form-field{
	 background: none;
	 color:#fff;
 }
 .is-invalid{
	 border:1px solid red;
 }
 .invalid-feedback{
	 color:red;
 }
 .welcome{
   	font-family: Calibri;
	 font-size: 518%;
	 color:#c3c3c3;
 }
 .text-style{
	 font-family: sans-serif;
	 color:#fff;
	 font-size:1rem;
 }
 .text-title{
	 font-family:Calibri;
	 color:#666;
	 font-size:1.5rem;
	 color:#fff;
 }
</style>



// WEBPACK FOOTER //
// src/components/auth/login/login.vue